<template>
  <div>
    <section class="homeblock1">
    <div class="container">
        <div class="row">
            <div class="col-md-4 col-sm-6 col-xs-12">
                <div class="box-wrap">
                    <h4><a >26 volunteers</a></h4>
                </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
                <div class="box-wrap">
                    <h4><a >5000+ Kids Fed</a></h4>
                </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
                <div class="box-wrap">
                    <h4><a >2000+ Kids Clothed</a></h4>
                </div>
            </div>
        </div>
    </div>
</section>
  </div>
</template>

<script>
export default {

}
</script>

<style>
@import '../../assets/css/style-starter.css';
@import url('https://fonts.googleapis.com/css?family=Roboto');
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&display=swap');
</style>